<template>
    <div class="w-full shrink-0 px-2 pb-2 md:mx-auto md:max-w-(--breakpoint-md) md:px-4">
        <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
            <BaseButton theme="neutral" class="w-full justify-center rounded-lg sm:w-auto" :disabled="disabled" @click="emit('keep-editing')"> Keep editing </BaseButton>
            <BaseButton theme="primary" class="base-btn-dark w-full justify-center sm:w-auto" :disabled="disabled" @click="emit('lock-in')"> Lock it in </BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";

withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false });
const emit = defineEmits<{ "keep-editing": []; "lock-in": [] }>();
</script>
